module.exports = function() {
    var Arrays = {};

    /**
     * Get the nested value from an array using dot notation
     *
     * @param string
     * @return number
     */
    Arrays.extractDotValue = function(data, dotKey) {
        var ex = dotKey.split('.'),
            arr = data,
            val = null;

        for(var i = 0; i < ex.length; i++) {
            if(typeof arr[ex[i]] !== 'undefined') {
                arr = arr[ex[i]];
            }
        }

        if(typeof arr == 'number' || typeof arr == 'string') {
            val = arr;
        }

        return val;
    };

    //http://stackoverflow.com/a/28631880/761793
    Arrays.mergeStringArrays = function(a, b) {
        var hash = {}, i;
        var aLength = a.length;
        var bLength = b.length;
        for (i = 0; i < aLength; i++) {
            hash[a[i]]=true;
        }
        for (i = 0; i < bLength; i++) {
            hash[b[i]]=true;
        }
        return Object.keys(hash);
    };

    return Arrays;
};